import { render, staticRenderFns } from "./CustomSenderName.vue?vue&type=template&id=6a944902&scoped=true&"
import script from "./CustomSenderName.vue?vue&type=script&lang=js&"
export * from "./CustomSenderName.vue?vue&type=script&lang=js&"
import style0 from "./CustomSenderName.vue?vue&type=style&index=0&id=6a944902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a944902",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
